// extracted by mini-css-extract-plugin
module.exports = {"link":"ResetPasswordPage_link__2oVwv"};